'use client'
import { Tr as ChakraTableRow } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { TableRowProps } from './TableRow.types'

export default forwardRef(function Tr(
  props: TableRowProps,
  ref: LegacyRef<HTMLTableRowElement>
) {
  return <ChakraTableRow {...props} ref={ref} translate="no" />
})
